export enum DiagnosisControlCodes {
  BASIC_INFO = 'diagnosis_basic_info',
  OVERVIEW = 'diagnosis_overview',
  WHAT_NEXT = 'diagnosis_what_next',
  RELATED_TOPICS = 'diagnosis_related_topics',
  TAGS = 'diagnosis_tags',
}
